import { constants } from '../constants'
import { strings } from '../context/LanguageContext/strings'
import { util } from '../util'

const promoDataModel = {
    getInitialPromoFilter: () => [
        {
            placed_at: 'tableToolBar',
            type: 'string',
            key: 'name',
            display_name: strings.SEARCH,
            display_value: '',
            post_value: '',
            defaultDisplayValue: '',
            defaultPostValue: '',
        },
        {
            type: 'list',
            key: 'placement_location',
            display_name:
                strings.SECTION_PROMOTIONS_DETAIL_EDIT_MARKETING_CONFIGURATIONS_FILTER_PLACEMENT,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
            postUtil: ({ list }) => {
                const placements = constants.getPlacements()
                return list.map(
                    placement =>
                        placements.find(({ display }) => `7NOW ${display}` === placement).value
                )
            },
        },
        {
            type: 'range',
            key: 'date_range',
            display_name: strings.SECTION_MANAGE_PROMOTIONS_TABLE_CONTENT_DATE,
            start_value: '',
            end_value: '',
            display_value: '',
            defaultDisplayValue: '',
        },
        {
            type: 'list',
            key: 'region',
            display_name: strings.REGION,
            display_value: [],
            post_value: null,
            defaultDisplayValue: [],
            defaultPostValue: null,
            baseFilterList: [],
            displayPillUtil: value => {
                const regions = constants.getRegions()
                return value?.map(
                    status => regions.find(({ value }) => value === status)?.display || status
                )
            },
            postUtil: function ({ list, value }) {
                /** posted filter query values for region filter */
                return util.regionFilterQuery({
                    list,
                    value,
                    post_value: this.post_value,
                    baseFilterList: this.baseFilterList,
                })
            },
            displayUtil: function ({ list, value }) {
                return value && value.length ? list.concat(value) : list
            },
        },
        {
            type: 'list',
            key: 'created_by',
            display_name: strings.SECTION_MANAGE_PROMOTIONS_TABLE_CREATED_BY,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
            baseFilterList: [],
            displayUtil: ({ list, value }) => {
                const updatedList = [...list]
                value &&
                    value.length &&
                    updatedList.indexOf(value) === -1 &&
                    updatedList.push(value)
                return updatedList
            },
            postUtil: config => util.getSuggestList(config),
        },
        {
            type: 'list',
            key: 'updated_by',
            display_name: strings.SECTION_MANAGE_PROMOTIONS_TABLE_UPDATED_BY,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
            baseFilterList: [],
            displayUtil: ({ list, value }) => {
                const updatedList = [...list]
                value &&
                    value.length &&
                    updatedList.indexOf(value) === -1 &&
                    updatedList.push(value)
                return updatedList
            },
            postUtil: config => util.getSuggestList(config),
        },
        {
            type: 'list',
            key: 'status',
            display_name: strings.STATUS,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
            displayPillUtil: value => {
                const statusFields = constants.getStatusFields()
                return value?.map(
                    status => statusFields.find(({ value }) => value === status)?.display || status
                )
            },
        },
        {
            type: 'list',
            key: 'is_live',
            display_name: strings.SECTION_MANAGE_PROMOTIONS_FILTER_STATUS_PRODUCTION,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
            displayPillUtil: value => {
                const publishedStatusFields = constants.getPublishedStatusFields()
                return value?.map(
                    status =>
                        publishedStatusFields.find(({ value }) => value === status)?.display ||
                        status
                )
            },
            postUtil: ({ list, key }) => util.getStatusValues(list, key),
        },
        {
            type: 'list',
            key: 'qa_is_live',
            display_name: strings.SECTION_MANAGE_PROMOTIONS_FILTER_STATUS_QA,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
            displayPillUtil: value => {
                const qaStatusFields = constants.getQaStatusFields()
                return value?.map(
                    status =>
                        qaStatusFields.find(({ value }) => value === status)?.display || status
                )
            },
            postUtil: ({ list, key }) => util.getStatusValues(list, key),
        },
    ],
}

export default promoDataModel
